



































import { Component, Prop, Vue, Ref } from "vue-property-decorator";
import { postNewComment } from "../../../helpers/comment-getter";
import { PostClass, CommentType } from "../../../types";

@Component
export default class NewComment extends Vue {
  @Prop() private post!: PostClass;
  @Ref() readonly newCommentTextarea!: HTMLTextAreaElement;
  @Ref() readonly openCommentFormButton!: HTMLButtonElement;

  private show_comment_form = false;
  private error = "";

  private new_comment: CommentType = {
    author: this.$store.state.user.id,
    content: "",
    post: this.post.id,
  };

  displayCommentForm() {
    this.show_comment_form = true;
    this.$nextTick(() => this.newCommentTextarea.focus());
  }

  addComment(): void {
    postNewComment(this.new_comment)
      .then(() => {
        this.$emit("new-comment-posted", {
          ...this.new_comment,
          author: this.$store.state.user.username,
        });
        this.close();
      })
      .catch((err) => {
        this.error = err.message;
      });
  }

  close() {
    this.new_comment.content = "";
    this.error = "";
    this.show_comment_form = false;
    this.$nextTick(() => this.openCommentFormButton.focus());
  }
}
